// // src/services/profileService.jsx
// import http from "./http";

// // Get Admin Profile
// export const getAdminDetails = async (id) => {
//   const res = await http.post("getAdminDetails", { id });
//   return res.data;
//   console.log(res);
// };

// // Update Profile (Correct API URL + field name "photo")
// export const updateAdminProfile = async (formData) => {
//   const res = await http.post("updateAdminProfile", formData);
//   return res.data;
// };



import http from "./http";

/* ================= GET PROFILE ================= */
export const getAdminDetails = async () => {
  try {
    const formData = new FormData();

    const res = await http.post("get_profile", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res.data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};

/* ================= UPDATE PROFILE ================= */
export const updateAdminProfile = async (formData) => {
  try {
    const res = await http.post("update_profile", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res.data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};